module.exports = __webpack_public_path__ + "ring-twilight.f16893ae76e167f009bd.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/ring-twilight.svg
// module id = ../../../../../src/assets/img/ring-twilight.svg
// module chunks = main